module.exports = __webpack_public_path__ + "img/icon.08c1915b.png";